export function applyPagination(documents, page, rowsPerPage) {
  const res = documents.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  return res;
}
